$(function() {

    // look for all dropdowns containing anchors with data-confirm-form-text attributes
    $(document).on('click', '.dropdown-menu li a[data-confirm-form-text]', function(e) {

        var el = $(e.target);
        var form = el.prev('form');
        var title = el.attr('data-confirm-form-title') || 'Are you sure?';
        var text = el.attr('data-confirm-form-text') || 'NOT SPECIFIED';
        var type = el.attr('data-confirm-form-type') || 'warning';

        swal({
            type: type,
            title: title,
            text: text,
            cancelButtonText: 'Cancel',
            showCancelButton: true,
            confirmButtonText: 'Yes, I\'m sure',
            closeOnConfirm: false,
        }, function(value) {

            if (value) {

                $('.sweet-alert h2').text('Please wait...');
                $('.sweet-alert p').css('display', 'none');
                $('.sa-button-container').css('display', 'none');
                $('.sa-button-container button').attr('disabled', '');

                form.submit();
            }
        });
    });

});